const PERMISSION_KEY= "notification:notification_setting";
const PAGE_URL = {
    NOTIFICATION_SETTING_PAGE: "/admin/notification/notification-setting"
}

export {PERMISSION_KEY, PAGE_URL}

